// extracted by mini-css-extract-plugin
export default {"label":"LevelLabel_label__4+gv4","gradient":"LevelLabel_gradient__-m6lP"};